import type { ReactElement } from 'react';

import { Card, Flex, Skeleton, Text } from '@rango-dev/whale';
import { Pagination } from '@rango-dev/whale/lab';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { InfoIconButton } from '../../common/InfoIconButton';
import { ListSkeleton } from '../../Profile/Leaderboard/List/ListSkeleton';
import { ArticleSkeleton } from '../Article/ArticleSkeleton';

import styles from './MarketingCampaign.module.css';

const LEADERBOARD_SKELETON_ROWS = 20;
const HEADING_INFO_ICON_SIZE = 15;

export function MarketingCampaignSkeleton(): ReactElement {
  const { t } = useTranslation();

  return (
    <Flex direction="column" width="100%" gap={{ initial: '4', md: '5' }}>
      <Skeleton
        className={styles.skeleton}
        height={{ initial: '331px', sm: '287px', md: '194px' }}
      />
      <Flex direction={{ initial: 'column', xl: 'row' }} gap={{ initial: '4', md: '5' }}>
        <Skeleton
          className={`${styles.skeleton} ${styles.taskCell}`}
          height={{ initial: '152px', sm: '112px', md: '240px' }}
        />
        <Skeleton
          className={`${styles.skeleton} ${styles.prizeCell}`}
          height={{ initial: '396px', sm: '388px', md: '240px' }}
        />
      </Flex>
      <Card variant="surface" size="3" className={styles.leaderboard}>
        <Flex justify="between" align="center" width="100%" px="2" pb={{ md: '2' }}>
          <Flex align="center" gap={{ initial: '2', sm: '4' }}>
            <Flex width="48px" align="start">
              <Text size="2" weight="bold">
                {t('Rank')}
              </Text>
            </Flex>
            <Text size="2" weight="bold">
              {t('User')}
            </Text>
          </Flex>
          <Flex align="center" gap="1">
            <Text size="2" weight="bold">
              {t('Transaction')}
            </Text>
            <InfoIconButton
              id="campaign-leaderboard-heading-info"
              iconSize={HEADING_INFO_ICON_SIZE}
              aria-label={t('Transaction')}
            />
          </Flex>
        </Flex>
        <ListSkeleton
          maxLength={LEADERBOARD_SKELETON_ROWS}
          avatarSize={{ initial: '3', md: '4' }}
          enableTopUserSkeleton
        />
        <Pagination.Skeleton />
      </Card>
      <ArticleSkeleton />
    </Flex>
  );
}
